import React, { Fragment } from "react";
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
// import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';



// export function addVendorRequest(event, cellValues, setVendorRequestOpen) {
//     debugger;

//     setVendorRequestOpen(true);
// };


// export function handleRequestCancel(setVendorRequestOpen) {
//     debugger;

//     setVendorRequestOpen(false);
// };
async function saveVendorRequest(data, showSuccess, showError) {
    var url = "vendors/sendvendorrequest";
    //var bearer = 'Bearer ' + data.accessToken;
    var bearer = localStorage.getItem('userToken');
debugger;
    var dataToSend = {
        vendorId: data.vendorId,
        emailAdditionalComments: data.emailbody,
        sentToEmail: data.email,
        requestedBy: 'Bob' //TODO: userid here
    }
    var result = await fetch(url, {
        method: 'POST',
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Authorization': bearer,
            'Content-Type': 'application/json'

        },
        body: JSON.stringify(dataToSend)
    });

    if (result.ok) {
        showSuccess("Vendor Request Initiated");
    } else {
        showError("Error occurred sending vendor request");
    }
}


const VendorRequestDialog = (props) => {

    const requestSubmit = (data) => {
        clearErrors();
        props.setVendorRequestOpen(false);
        saveVendorRequest(data, props.showSuccess, props.showError);

    };

   
    //const emailRe = RegExp('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?');
    const validationSchema = Yup.object().shape({
        vendorId: Yup.string(),
        accessToken: Yup.string(),
        email: Yup.string()
            .required('Email is required.')
            .max(150, 'Email not exceed 150 characters')
            .email('Email must be a valid email address.'),
        // note: Yup.string()
        //     .max(1500, 'Note must not exceed 1500 characters'),
        emailbody: Yup.string()
             .max(2500, 'Email must not exceed 2500 characters'),

    });

    const {
        register,
        //control,
        setValue,
        handleSubmit,
        clearErrors,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(validationSchema)
    });
    setValue("emailbody",props.initialRequestBody);

    return (
        <Dialog open={props.vendorRequestOpen} onClose={props.onClose} maxWidth='sm' fullWidth >
            <DialogTitle>
                <Box
                    component="span"
                    m={1}
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    Vendor PIA Request
                </Box>
            </DialogTitle>

            <form>
                <DialogContent>
                    <DialogContentText>
                    </DialogContentText>
                    <Fragment>
                        <Paper variant="outlined" >
                            {props.masterPiaExists && (<>
                                <Box px={3} py={2}>

                                    <p>
                                        <Typography variant="h8" color="error" align="center"> <b>Warning:</b>
                                            You are initiating a PIA request with a vendor that already has an active PIA in the Master list.
                                        </Typography>
                                    </p>
                                    <p>
                                        <Typography variant="h8" color="error" align="center">
                                            If you still want a vendor completed PIA for this software, please email contact@theprocesspros.ca and explain the request and we will ensure this work is done without PIA duplication.
                                        </Typography>
                                       </p>
                                </Box>

                            </>
                            )}
                            {!props.masterPiaExists && (<>
                                <Box px={3} py={2}>
                                    <Grid item xs={12} sm={12}>
                                        <TextField
                                            id="vendorId"
                                            name="vendorId"
                                            label="Vendor Email"
                                            hidden
                                            value={props.vendorId}
                                            margin="dense"
                                            {...register('vendorId')}
                                        />

                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <TextField
                                            id="accessToken"
                                            name="accessToken"
                                            label="accessToken"
                                            hidden
                                            value={props.accessToken}
                                            margin="dense"
                                            {...register('accessToken')}
                                        />

                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <TextField
                                            required
                                            id="email"
                                            name="email"
                                            label="Vendor Email"
                                            fullWidth
                                            margin="dense"
                                            {...register('email')}
                                        />
                                        <Typography variant="inherit" color="error.main">
                                            {errors.email?.message}
                                        </Typography>
                                    </Grid>
                                    {/* <Grid item xs={12} sm={12}>
                                        <TextField
                                            multiline
                                            id="note"
                                            name="note"
                                            label="Additional Notes to Vendor"
                                            fullWidth
                                            margin="dense"
                                            {...register('note')}
                                        />
                                        <Typography variant="inherit" color="error.main">
                                            {errors.note?.message}
                                        </Typography>
                                    </Grid> */}
                                    <Grid item xs={12} sm={12}>
                                        <TextField
                                            multiline
                                            minRows={7}
                                            id="emailbody"
                                            name="emailbody"
                                            label="Note to attach to Vendor Request"
                                            
                                            fullWidth
                                            margin="dense"
                                            {...register('emailbody')}
                                        />
                                        <Typography variant="inherit" color="error.main">
                                            {errors.emailbody?.message}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <Typography variant="inherit" color="error.main"> 
                                            *Note: The email that goes to the vendor explains why you are asking for a privacy impact assessment and how you will use that information.  If you want to add a note to the space above to personalize it, it will go at the beginning of the email and you will be copied on that email.
                                        </Typography>
                                    </Grid>
                                </Box>
                            </>
                            )}
                        </Paper>
                    </Fragment>
                </DialogContent>
                <DialogActions>
                    {!props.masterPiaExists && (<>
                        <Button color="primary" onClick={handleSubmit(requestSubmit)} >Send</Button>
                    </>
                    )}
                    <Button onClick={props.onClose}>Cancel</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}

export default VendorRequestDialog;
